import { addLocalDays, localDayKey, weekRange } from '../../../../Utils/dates/localDay';
import { formatDayMonth } from '../../../../Utils/dates/formatDate';

const DOW = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const km = metres => (typeof metres === 'number' && Number.isFinite(metres) ? metres : 0) / 1000;
const one = value => (Math.round(value * 10) / 10).toFixed(1);
const num = value => Math.round(value * 10) / 10;

/** Monday-to-Sunday (local) distance bars. Planned = every session that day, whatever its status. */
export const buildWeeklyLoad = (rows, now) => {
    const { from } = weekRange(now);
    const days = DOW.map((label, i) => {
        const date = addLocalDays(from, i);
        return { key: localDayKey(date), label, date, plannedKm: 0, completedKm: 0, sessions: 0, completedSessions: 0 };
    });
    const byKey = new Map(days.map(d => [d.key, d]));

    (rows || []).forEach(r => {
        const day = byKey.get(localDayKey(r.workoutStart));
        if (!day) return;
        day.sessions += 1;
        day.plannedKm += km(r.volume);
        if (r.status === 'Completed') {
            day.completedSessions += 1;
            day.completedKm += km(r.volume);
        }
    });

    days.forEach(d => {
        d.plannedKm = num(d.plannedKm);
        d.completedKm = num(d.completedKm);
        d.isRest = d.sessions === 0;
    });

    const totals = {
        completedKm: num(days.reduce((a, d) => a + d.completedKm, 0)),
        plannedKm: num(days.reduce((a, d) => a + d.plannedKm, 0)),
        completedSessions: days.reduce((a, d) => a + d.completedSessions, 0),
        sessions: days.reduce((a, d) => a + d.sessions, 0)
    };
    const ariaLabel =
        'Distance by day this week. ' +
        days
            .map(d =>
                d.isRest
                    ? `${d.label} rest`
                    : d.completedKm > 0
                    ? `${d.label} ${one(d.completedKm)} of ${one(d.plannedKm)} km completed`
                    : `${d.label} ${one(0)} of ${one(d.plannedKm)} km planned`
            )
            .join('. ');

    return {
        days,
        totals,
        ariaLabel,
        rangeLabel: `${formatDayMonth(days[0].date)} – ${formatDayMonth(days[6].date)}`
    };
};
